import AccountBindCode from './accountBindCode.vue'
import {jump} from '@utils'




export default [{
    path: '/accountBindCode',
    name:'accountBindCode',
    component:AccountBindCode,
    beforeEnter: (to, from, next) => {
        jump.preAccountBindCode(()=>{
            next()
        }) 
      }
}]